"use client";

import React, { useState } from "react";
import { MapPin, Search } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
const locations = [{
  name: "Coral Gables",
  path: "/home-inspection-coral-gables-fl/"
}, {
  name: "South Miami",
  path: "/home-inspection-south-miami-fl/"
}, {
  name: "Palmetto Bay",
  path: "/home-inspection-palmetto-bay-fl/"
}, {
  name: "Pinecrest",
  path: "/home-inspection-pinecrest-fl/"
}, {
  name: "Miami Beach",
  path: "/home-inspection-miami-beach-fl/"
}, {
  name: "Fort Lauderdale",
  path: "/home-inspection-fort-lauderdale-fl/"
}];
export default function ServiceAreas() {
  const [searchQuery, setSearchQuery] = useState("");
  const filteredLocations = locations.filter(loc => loc.name.toLowerCase().includes(searchQuery.toLowerCase()));
  return <section id="service-areas" className="dark bg-background text-foreground py-24 px-4 lg:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {}
        <div className="flex flex-col">
          <div className="mb-8">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight mb-4">
              Areas We <span className="text-primary">Serve</span>
            </h2>
            <p className="text-lg text-muted-foreground max-w-md leading-relaxed">
              Trusted Inspections serves South Florida, including Miami-Dade, Broward, the Florida Keys, and premium residential markets such as Coral Gables, South Miami, Palmetto Bay, Pinecrest, Miami Beach, and Fort Lauderdale.
            </p>
          </div>

          <div className="relative max-w-md mb-10">
            <div className="relative flex items-center">
              <Search className="absolute left-3 w-5 h-5 text-muted-foreground" />
              <Input type="text" placeholder="Find your city..." className="pl-10 pr-24 py-6 text-base bg-muted/20 border-border/50 focus-visible:ring-primary rounded-lg" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />
              <Button variant="default" className="absolute right-1.5 h-9 px-4 rounded-md font-semibold" onClick={() => {}}>
                Search
              </Button>
            </div>
          </div>

          <div className="min-h-[200px]">
            {filteredLocations.length > 0 ? <ul className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-8">
                {filteredLocations.map((location, i) => <li data-index={i} key={location.name}>
                    <Link to={location.path} className="group flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors duration-200 py-1">
                      <MapPin className="w-4 h-4 opacity-50 group-hover:opacity-100 transition-opacity" />
                      <span className="font-medium">{location.name}</span>
                    </Link>
                  </li>)}
              </ul> : <div className="flex flex-col items-center justify-center h-full text-center p-8 border border-dashed border-border/50 rounded-lg bg-muted/5">
                <MapPin className="w-8 h-8 text-muted-foreground mb-3 opacity-50" />
                <p className="text-muted-foreground font-medium">
                  No cities found matching "{searchQuery}"
                </p>
                <p className="text-sm text-muted-foreground mt-1">
                  Please try a different search term or contact us to confirm
                  service in your area.
                </p>
              </div>}
          </div>
        </div>

        {}
        <div className="relative w-full aspect-square md:aspect-[4/3] lg:aspect-square rounded-2xl overflow-hidden bg-muted/10 border border-border/30 flex items-center justify-center p-8 lg:p-12 shadow-2xl shadow-black/50">
          {}
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_70%)] opacity-[0.03]"></div>
          <div className="absolute top-1/4 left-1/4 w-2 h-2 rounded-full bg-primary animate-pulse"></div>
          <div className="absolute top-1/2 right-1/3 w-3 h-3 rounded-full bg-primary/80 animate-pulse delay-75"></div>
          <div className="absolute bottom-1/3 left-1/2 w-2 h-2 rounded-full bg-primary/60 animate-pulse delay-150"></div>
          
          <img src="https://crack-snail.10web.cloud/wp-content/uploads/2026/03/service_area_map_watermark.webp" alt="Minimalist map of Florida highlighting South Florida with Miami, Kendall, Homestead, and the Florida Keys" className="w-full h-full object-contain relative z-10 drop-shadow-[0_0_15px_rgba(255,100,0,0.1)]" />
          
          {}
          <div className="absolute inset-0 bg-gradient-to-tr from-background/80 via-transparent to-transparent z-20 pointer-events-none"></div>
        </div>
      </div>
    </section>;
}